export const ADDRESS_DUPLICATE_GRID_COLUMNS = [
  { field: 'AddressID', headerName: 'Address ID', width: 140 },
  { field: 'FullAddressText', headerName: 'Full Address', flex: 1, minWidth: 250 },
];
export const ADDRESS_DUPLICATE_FIELD_LABELS = {
  AddressNumber: 'Address Number',
  AddressNumberPrefix: 'Address Number Prefix',
  AddressNumberSuffix: 'Address Number Suffix',
  StreetName: 'Street Name',
  StreetType: 'Street Type',
  PreDirection: 'Pre Direction',
  PostDirection: 'Post Direction',
  ptsCityID: 'City',
  State: 'State',
  PostalCode: 'Postal Code',
  PostalCodeExtension: 'Postal Code Extension',
};
